
import React, { useState, useContext, useEffect } from "react";
import { Card, CardBody, CardHeader, CardTitle, CardFooter, Col, Row, Container, Button, InputGroup } from "reactstrap";
import { Link, useParams } from 'react-router-dom';

import UseMoondanceApi from "../../lib/api";
import MoondanceLayout from "../../lib/layout";
import { MoondanceContext } from '../../../App';

import MoondanceTable from "../../lib/components/MoondanceTable.js";
import DOMPurify from 'dompurify';

import { buildTableData, buildAccountParameter } from "../../lib/formatData";
import Loading from "../../lib/components/Loading.js";
import { set } from "lodash";





const ListFiles = () => {
    const moondanceApi = UseMoondanceApi();

    const params = useParams();
    const id = (params.id ? params.id : false);
    const { userCurrency } = useContext(MoondanceContext);
    const { selectedAccountList } = useContext(MoondanceContext);
    const { selectedStatus } = useContext(MoondanceContext);
    const { lastUpdate, setLastUpdate } = useContext(MoondanceContext);
    const [loading, setLoading] = useState(true);
    const [files, setFiles] = useState([]);
    const createMarkup = (html) => {
        return { __html: DOMPurify.sanitize(html) };
    };

    async function getFiles(account_id) {
        if (parseInt(id)) {
            let result = await moondanceApi.getFileListForPosition({
                account: buildAccountParameter(selectedAccountList),
                status: buildAccountParameter(selectedStatus),
                position_id: id
            });
            console.log('result', result);
            setFiles(result.files);
          
        } else {
            let result = await moondanceApi.getFileListForAccount({
                account: buildAccountParameter(selectedAccountList),
                status: buildAccountParameter(selectedStatus),

            });
            setFiles(result.files);
        }
        setLoading(false);
    };

    useEffect(() => {
        getFiles();

    }, [selectedAccountList, selectedStatus, id]);

    useEffect(() => {
        console.log('files', files)
    }, [files]);
    
    
    function loadFile(file_id) {
        return async (e) => {
            e.preventDefault();
            console.log('load file', file_id);
            let result = await moondanceApi.getFileUrl({
                file_id: file_id
            });
            console.log('result', result);
            if (result && result.file_url) {
                window.open(result.file_url, '_blank');
            } else {
                console.error('Failed to load file');
            }
        };
    }




    return (
        <div >
            <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '1em' }}>

                <Link className="btn btn-outline-primary" to={'../addFile' + (id ? '/' + id : '')}>Add File</Link>
            </div>
            {(loading ? <Loading /> : null)}
            
            
            {(files && files.length > 0) ?
                <div>
                    <MoondanceTable
                        key={`fileList-${lastUpdate}`}
                        title="List Files"
                        rows={files}
                        defaultSort={{ key: 'file_date_timestamp', direction: 'descending' }}
                        columns={[
                          
                          
                            { label: 'Date', field: 'file_date_timestamp', format: 'timestampToDate' },
                            { 
                                label: 'Name',
                                field: 'name',
                                customFormat : (row) => {return <Link onClick={loadFile(row.file_id)}><i className =" mdi mdi-download"></i> {row.description}</Link>}
                            },
                          
                            { 
                                label: 'Position',
                                field: 'asset_name',
                                hide:(params.id =='files' ? false : true ),
                                customFormat : (row) => {return <Link to={'/position/' + row.position_id}><i className="mdi mdi-eye"></i> {row.asset_name} </Link>}
                               
                            },
                            { label: 'Uploaded by', field: 'created_by_name' },
                            {   
                                label: 'Id', 
                                field: 'file_id',
                                customFormat: (row) => {
                                    return  (
                                        <Link className="primary" to={'/editFile/' + row.file_id}>
                                            <i className="fas fa-edit"></i> Edit
                                        </Link>
                                    )
                                }
                        },
                            
                        ]}
                        ></MoondanceTable>

                </div>
                :
                <div>
                    <Card>
                        <CardBody >
                            <CardTitle>Files</CardTitle>

                            <p>No file found </p>

                        </CardBody>
                    </Card>
                </div>}

        </div >
    )

}
export default ListFiles;